import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/calculate",
    name: "calculate",
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/CalculateView.vue"),
  },
  {
    path: "/keyword-search/:keyword",
    name: "keyword-search",
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/PicnicSearchView.vue"),
  },
  {
    path: "/browse",
    name: "browse",
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/BrowseView.vue"),
  },
  {
    path: "/about-us",
    name: "about-us",
    // route level code-splitting
    // this generates a separate chunk (About.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/help",
    name: "help",
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/HelpView.vue"),
  },
  {
    path: "/privacy-policy",
    name: "privacy_policy",
    component: () => import("../views/PrivacyPage.vue"),
  },
  {
    path: "/imprint",
    name: "imprint",
    component: () => import("../views/ImprintPage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
